/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ListGroups_refetchableVariables = {
    count?: number | null | undefined;
    cursor?: string | null | undefined;
    regex?: string | null | undefined;
};
export type ListGroups_refetchableResponse = {
    readonly " $fragmentRefs": FragmentRefs<"ListGroups_Query">;
};
export type ListGroups_refetchable = {
    readonly response: ListGroups_refetchableResponse;
    readonly variables: ListGroups_refetchableVariables;
};



/*
query ListGroups_refetchable(
  $count: Int = 15
  $cursor: String
  $regex: String
) {
  ...ListGroups_Query_V9kkX
}

fragment ListGroups_Query_V9kkX on Query {
  groupConnection(first: $count, sort: NAME_ASC, after: $cursor, filter: {_operators: {name: {regex: $regex}}}) {
    edges {
      node {
        _id
        ...ListItemGroup_Node
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ListItemGroup_Node on Node {
  __isNode: __typename
  ...ListItemNode_Node
  ... on Group {
    ...TypographyNodeName_Node
  }
}

fragment ListItemNode_Node on Node {
  __isNode: __typename
  __typename
  id
  ... on User {
    name
  }
  ... on Provider {
    name
  }
  ... on Patient {
    name
  }
  ... on Group {
    groupName: name
  }
  ... on Audit {
    nameJson: new
  }
}

fragment TypographyNodeName_Node on Node {
  __isNode: __typename
  ... on Group {
    groupName: name
  }
  ... on Patient {
    name
  }
  ... on Provider {
    name
  }
  ... on User {
    name
  }
  ... on Facility {
    facilityName: name
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 15,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "regex"
  }
],
v1 = {
  "kind": "Variable",
  "name": "regex",
  "variableName": "regex"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "fields": [
      {
        "fields": [
          {
            "fields": [
              (v1/*: any*/)
            ],
            "kind": "ObjectValue",
            "name": "name"
          }
        ],
        "kind": "ObjectValue",
        "name": "_operators"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "NAME_ASC"
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ListGroups_refetchable",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ListGroups_Query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ListGroups_refetchable",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "GroupConnection",
        "kind": "LinkedField",
        "name": "groupConnection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Group",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": (v3/*: any*/),
                        "type": "User",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v3/*: any*/),
                        "type": "Provider",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v3/*: any*/),
                        "type": "Patient",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "groupName",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "facilityName",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  }
                                ],
                                "type": "Facility",
                                "abstractKey": null
                              }
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "type": "Group",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "nameJson",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "new",
                            "storageKey": null
                          }
                        ],
                        "type": "Audit",
                        "abstractKey": null
                      }
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": [
          "sort",
          "filter"
        ],
        "handle": "connection",
        "key": "ListGroups_groupConnection",
        "kind": "LinkedHandle",
        "name": "groupConnection"
      }
    ]
  },
  "params": {
    "cacheID": "677b6f594a4666ca66ae2a07957b2107",
    "id": null,
    "metadata": {},
    "name": "ListGroups_refetchable",
    "operationKind": "query",
    "text": "query ListGroups_refetchable(\n  $count: Int = 15\n  $cursor: String\n  $regex: String\n) {\n  ...ListGroups_Query_V9kkX\n}\n\nfragment ListGroups_Query_V9kkX on Query {\n  groupConnection(first: $count, sort: NAME_ASC, after: $cursor, filter: {_operators: {name: {regex: $regex}}}) {\n    edges {\n      node {\n        _id\n        ...ListItemGroup_Node\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ListItemGroup_Node on Node {\n  __isNode: __typename\n  ...ListItemNode_Node\n  ... on Group {\n    ...TypographyNodeName_Node\n  }\n}\n\nfragment ListItemNode_Node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on User {\n    name\n  }\n  ... on Provider {\n    name\n  }\n  ... on Patient {\n    name\n  }\n  ... on Group {\n    groupName: name\n  }\n  ... on Audit {\n    nameJson: new\n  }\n}\n\nfragment TypographyNodeName_Node on Node {\n  __isNode: __typename\n  ... on Group {\n    groupName: name\n  }\n  ... on Patient {\n    name\n  }\n  ... on Provider {\n    name\n  }\n  ... on User {\n    name\n  }\n  ... on Facility {\n    facilityName: name\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c579efcc4754e0bcb144a3af65895ceb';
export default node;
